exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".market-manager{width:100%;display:flex}.market-manager-left-nav{width:308px}.market-manager-content{width:calc(100% - 308px);padding-top:30px;padding-right:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c8a66364","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/MarketManager.vue
// module id = 161
// module chunks = 0